(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bygdetryck-city-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-city-finder]').forEach((finder)=>{const input=finder.querySelector('.bt-city-finder__search');const results=finder.querySelector('.bt-city-finder__results');const cities=JSON.parse(finder.querySelector('[data-city-data]').textContent);const normalise=(value)=>value.toLocaleLowerCase('sv-SE').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();const render=()=>{const query=normalise(input.value);const matches=query?cities.filter((city)=>normalise(city.name).includes(query)).slice(0,8):[];results.hidden=matches.length===0;input.setAttribute('aria-expanded',String(matches.length>0));results.innerHTML=matches.map((city)=>`<li><a href="/collections/${city.handle}"><strong>${city.name}</strong><small>${city.region}</small></a></li>`).join('')};input.addEventListener('input',render);input.addEventListener('keydown',(event)=>{if(event.key==='Enter'){event.preventDefault();event.stopPropagation();const query=normalise(input.value);const destination=cities.find((city)=>normalise(city.name)===query)||cities.find((city)=>normalise(city.name).includes(query));if(destination){const preview=finder.dataset.previewTheme?`?preview_theme_id=${finder.dataset.previewTheme}`:'';window.open(`${finder.dataset.storefrontUrl}/collections/${destination.handle}${preview}`, '_top')}};if(event.key==='Escape'){input.value='';render();input.blur()}});document.addEventListener('click',(event)=>{if(!finder.contains(event.target)){results.hidden=true;input.setAttribute('aria-expanded','false')}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-city-filter]').forEach((filter) => {
    const input = filter.querySelector('input');
    const scope = filter.closest('results-list');
    const empty = filter.querySelector('.bt-collection-city-filter__empty');
    const normalise = (value) => value.toLocaleLowerCase('sv-SE').normalize('NFD').replace(/[\\u0300-\\u036f]/g, '').trim();
    const apply = () => {
      const query = normalise(input.value);
      const cards = scope.querySelectorAll('[data-city-search]');
      let visible = 0;
      cards.forEach((card) => {
        const match = query === '' || normalise(card.dataset.citySearch).includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      empty.hidden = visible !== 0 || query === '';
    };
    input.addEventListener('input', apply);
    input.addEventListener('keydown', (event) => { if (event.key === 'Enter') event.preventDefault(); });
    new MutationObserver(apply).observe(scope, { childList: true, subtree: true });
  });


  const productColorCycle = [
    ['black'],
    ['white', 'natural', 'ecru'],
    ['french-navy', 'navy', 'blue'],
    ['khaki', 'beige'],
    ['pink', 'orange', 'coral', 'peach', 'salmon'],
    ['yellow', 'mustard', 'orange', 'burgundy', 'dark-heather-grey', 'anthracite']
  ];

  const applyProductColorCycle = (scope = document) => {
    scope.querySelectorAll('[data-color-cycle]').forEach((card) => {
      if (card.dataset.colorCycleApplied === 'true') return;

      const markers = productColorCycle[Number(card.dataset.colorCycle)] || [];
      const primary = card.querySelector('.product-media__image');
      const mockups = (card.dataset.frontMockups || '')
        .split('||')
        .filter(Boolean)
        .map((entry) => {
          const [url, source] = entry.split('::');
          return { url, source: (source || '').toLowerCase() };
        })
        .filter((mockup) => mockup.url && mockup.source);

      const selectedMockup =
        mockups.find((mockup) => markers.some((marker) => mockup.source.includes(marker))) || mockups[0];

      if (!primary || !selectedMockup) return;

      primary.src = selectedMockup.url;
      primary.removeAttribute('srcset');
      primary.removeAttribute('sizes');
      card.dataset.colorCycleApplied = 'true';
    });
  };

  applyProductColorCycle();
  requestAnimationFrame(() => applyProductColorCycle());
  window.setTimeout(() => applyProductColorCycle(), 300);
  window.setTimeout(() => applyProductColorCycle(), 1000);
  document.addEventListener('DOMContentLoaded', () => applyProductColorCycle(), { once: true });
  document.querySelectorAll('results-list').forEach((results) => {
    new MutationObserver(() => applyProductColorCycle(results)).observe(results, { childList: true, subtree: true });
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
